import(/* webpackMode: "eager", webpackExports: ["ContributionGrid"] */ "/vercel/path0/components/contribution-grid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GitHubErrorBoundary"] */ "/vercel/path0/components/error-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeToggle"] */ "/vercel/path0/components/theme-toggle.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.35_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
